import { App } from 'vue'

import {
  CardComponent,
  ClosingComponent,
  CollapseComponent,
  Divider,
  ExpansionPanel,
  IntroComponent,
  RichtextResolver,
  WPDownloadButton,
  WPElementButton,
  WPElementMedia,
  WPStepList,
} from './components'
import { blokMainComponent, downloadBtnOptions, richTextOptions } from './types/injection-composables'
import { RichTextOptions } from './types/richtext'
import { TrackingHandler } from './types/tracking'
import { DownloadButtonOptions } from './types/download-button'

export * from './components'
export * from './types/richtext'
export * from './types/injection-composables'
export * from './types/assets'
export * from './utils'
export * from './types/tracking'
export { useGetInternalLinkFromUrl, useCalcedLink } from './composables/calcedLink'

export interface PluginOptions {
  richText: RichTextOptions,
  downloadBtn: DownloadButtonOptions,
  tracking: TrackingHandler
}

let trackingHandler: TrackingHandler | null = null
export const useTracking = () => {
  if (trackingHandler === null) {
    throw new Error('Trying to use tracking handler without having it initialized in the shared-bloks plugin.')
  }
  return trackingHandler
}

export default {
  install(app: App, options: PluginOptions) {
    app.component('BlokDivider', Divider)
    app.component('BlokRichtextResolver', RichtextResolver)
    app.component('CardComponent', CardComponent)
    app.component('ClosingComponent', ClosingComponent)
    app.component('CollapseComponent', CollapseComponent)
    app.component('IntroComponent', IntroComponent)
    app.component('WPBlockExpansionPanel', ExpansionPanel)
    app.component('WPDownloadButton', WPDownloadButton)
    app.component('WPElementButton', WPElementButton)
    app.component('WPElementMedia', WPElementMedia)
    app.component('WPStepList', WPStepList)

    app.provide(richTextOptions, options.richText)
    app.provide(downloadBtnOptions, options.downloadBtn)
    app.provide(blokMainComponent, undefined)
    
    trackingHandler = options.tracking

    app.config.globalProperties.$sharedBloksInitialized = true
  },
}
